import axios from '@/user/axios.js'
import { fileDownload } from '@/utils'

const moduleAmcEcUserAnalysis = {
  namespaced: true,
  state: {
    ecUserAnalysis: [],
    reportData: {
      sales: [],
      pageViews: [],
      salesByBrand: []
    }
  },
  getters: {},
  mutations: {
    SET_EC_USER_ANALYSIS (state, data) {
      state.ecUserAnalysis = data
    },
    SET_REPORT_DATA (state, data) {
      state.reportData = {
        ...state.reportData,
        ...data
      }
    }
  },
  actions: {
    fetchBrand: (context, payload) => {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/ec-user-analysis/brand/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_REPORT_DATA', {
              salesByBrand: res.data.data
            })
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchEcUserAnalysis: (context, payload) => {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/ec-user-analysis/${sellerId}`)
          if (res.data.success) {
            context.commit('SET_EC_USER_ANALYSIS', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    uploadEcUserAnalysis: (context, payload) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      return new Promise(async (resolve, reject) => {
        const { file, overwrite } = payload
        const formData = new FormData()
        formData.append('file', file)
        formData.append('overwrite', overwrite)
        formData.append('name', encodeURIComponent(file.name))
        try {
          const res = await axios.post(`/api/amc-reports/ec-user-analysis/upload/${sellerId}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    downloadTemplate (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get(`/api/amc-reports/ec-user-analysis/template`, {
            responseType: 'blob',
            params: payload
          })
          const fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1])
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchSalesReports (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/ec-user-analysis/sales/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_REPORT_DATA', {
              sales: res.data.data
            })
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    fetchPageViewReports (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/ec-user-analysis/page-view/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_REPORT_DATA', {
              pageViews: res.data.data
            })
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    downloadCSV (context, payload) {
      return new Promise(async (resolve, reject) => {
        const sellerId = context.rootState.account.activeAccount.sellerId
        try {
          const res = await axios.get(`/api/amc-reports/ec-user-analysis/download/${sellerId}`, {
            responseType: 'blob',
            params: payload
          })
          const fileName = `自社ECユーザー分析_${payload.action === 'sales' ? '売上' : 'ページビュー'}.csv`
          fileDownload(res.data, fileName)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleAmcEcUserAnalysis
